module.exports = __webpack_public_path__ + "assets/img/tx15b_2.f78e6f77.jpg";